import React from "react";
import business_classes from "../../Assets/03/business-classes.png";
import complience_manager from "../../Assets/03/complience-manager.png";
import culturer_sesntivity from "../../Assets/03/culturer-sesntivity.png";
import end_end from "../../Assets/03/end- end.png";
import specialize_services from "../../Assets/03/global-business 1.svg";
import unitedStates from "../../Assets/03/us.svg";
import germany from "../../Assets/03/germany.svg";
import Canada from "../../Assets/03/canada.svg";
import Australia from "../../Assets/03/Australia.svg";
import india from "../../Assets/03/india.svg";
import unitedArabEmirates from "../../Assets/03/uae.svg";
const International = () => {
  return (
    <>
      <section className="recruitment" id="international-recruitment">
        <div className="container  ">
          <div className="row">
            <div className="col-md-12">
              <div className="main-title">
                <h3>
                  <span>03</span> International Recruitment
                </h3>
                <p className="mt-md-0 mt-3">
                  Expand your talent pool globally with Anaxistech's specialized
                  International Recruitment services. In today's interconnected
                  world, sourcing talent beyond borders can give your company a
                  significant competitive advantage. We expertly navigate the
                  complexities of international hiring, connecting you with
                  highly skilled professionals from around the globe to meet
                  your unique business requirements.
                </p>
              </div>
            </div>
          </div>

          <div className="terms-condition">
            <div className="global-network">
              <div className="icons-details">
                <img src={business_classes} alt="" srcset="" />
              </div>
              <div className="main-title">
                <h4>Global Talent Network</h4>
                <p>
                  Leverage our extensive network to access diverse candidates
                  with niche skills and multilingual capabilities from various
                  countries.
                </p>
              </div>
            </div>

            <div className="global-network">
              <div className="icons-details">
                <img src={complience_manager} alt="" srcset="" />
              </div>
              <div className="main-title">
                <h4>Compliance and Regulations</h4>
                <p>
                  We ensure adherence to international labor laws, visa
                  requirements, immigration processes, and local regulations in
                  both the origin and destination countries.
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="only-first">
                <div className="global-network">
                  <div className="icons-details">
                    <img src={culturer_sesntivity} alt="" srcset="" />
                  </div>
                  <div className="main-title">
                    <h4>Cultural Sensitivity</h4>
                    <p>
                      Our team understands the nuances of international
                      recruitment, facilitating smooth transitions and
                      successful placements for candidates in new environments.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="terms-condition">
            <div className="global-network">
              <div className="icons-details">
                <img src={end_end} alt="" srcset="" />
              </div>
              <div className="main-title">
                <h4>End-to-End Support</h4>
                <p>
                  Leverage our extensive network to access diverse candidates
                  with niche skills and multilingual capabilities from various
                  countries.
                </p>
              </div>
            </div>

            <div className="global-network">
              <div className="icons-details">
                <img src={specialize_services} alt="" srcset="" />
              </div>
              <div className="main-title">
                <h4>Specialized Industries</h4>
                <p>
                  We have proven success in recruiting international talent for
                  sectors facing skill shortages, ensuring you find the
                  expertise.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="precense precense_desktop mt-2 ">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="main-title">
                <h3>International Presence</h3>
              </div>
            </div>
          </div>

          <div className="row pt-20">
            <div className="col-md-2">
              <div className="country_details">
                <div className="country_flg">
                  <img
                    src={unitedStates}
                    className="flag_ico"
                    alt=""
                    srcset=""
                  />
                </div>
                <div className="country_name">
                  <p>United States</p>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="country_details">
                <div className="country_flg">
                  <img src={germany} className="flag_ico" alt="" srcset="" />
                </div>
                <div className="country_name">
                  <p>Germany</p>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="country_details">
                <div className="country_flg">
                  <img src={Canada} className="flag_ico" alt="" srcset="" />
                </div>
                <div className="country_name">
                  <p>Canada</p>
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-20">
            <div className="col-md-2">
              <div className="country_details">
                <div className="country_flg">
                  <img src={Australia} className="flag_ico" alt="" srcset="" />
                </div>
                <div className="country_name">
                  <p>Australia</p>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="country_details">
                <div className="country_flg">
                  <img src={india} className="flag_ico" alt="" srcset="" />
                </div>
                <div className="country_name">
                  <p>India</p>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="country_details">
                <div className="country_flg">
                  <img
                    src={unitedArabEmirates}
                    className="flag_ico"
                    alt=""
                    srcset=""
                  />
                </div>
                <div className="country_name">
                  <p>United Arab Emirates</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="precense precense_mobile">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="main-title">
                <h3>International Presence</h3>
              </div>
            </div>
          </div>

          <div className="row pt-20">
            <div className="col-md-2">
              <div className="country_details">
                <div className="country_flg">
                  <img
                    src={unitedStates}
                    className="flag_ico"
                    alt=""
                    srcset=""
                  />
                </div>
                <div className="country_name">
                  <p>United States</p>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="country_details">
                <div className="country_flg">
                  <img src={germany} className="flag_ico" alt="" srcset="" />
                </div>
                <div className="country_name">
                  <p>Germany</p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-2">
              <div className="country_details">
                <div className="country_flg">
                  <img src={Canada} className="flag_ico" alt="" srcset="" />
                </div>
                <div className="country_name">
                  <p>Canada</p>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="country_details">
                <div className="country_flg">
                  <img src={Australia} className="flag_ico" alt="" srcset="" />
                </div>
                <div className="country_name">
                  <p>Australia</p>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="country_details">
                <div className="country_flg">
                  <img src={india} className="flag_ico" alt="" srcset="" />
                </div>
                <div className="country_name">
                  <p>India</p>
                </div>
              </div>
            </div>

            <div className="col-md-2">
              <div className="country_details">
                <div className="country_flg">
                  <img
                    src={unitedArabEmirates}
                    className="flag_ico"
                    alt=""
                    srcset=""
                  />
                </div>
                <div className="country_name">
                  <p>United Arab Emirates</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default International;
